import React, { useState, useEffect, useRef, useContext } from "react";
import { FaEdit, FaSave, FaSearch, FaTimes, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/AxiosInstance";
import { AppContext } from "../context/AppContext";
import Select from "react-select";
import { useDebounce } from "../utils/usedebounce";
import Pagination from "../widgets/Pagination";
import { useMediaQuery } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import ConfirmationModalInput from "../widgets/ConfrimationModalInput";
import ConfirmationModalRlsMail from "../widgets/ConfirmationModalRlsMail";
import UserManagementTitleList from "./UserManagementTitleList";
import ConfirmationModalDeleteMail from "../widgets/ConfirmationModalDeleteMail";
import SegUserManagement from "./SegUserManagement";
import { getActivityActor } from "../utils/activityActor";

const UserManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [activeTab, setActiveTab] = useState("Abrams BI User Management");
  const [editUserId, setEditUserId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageTitle, setCurrentPageTitle] = useState(1);
  const [currentPageSeg, setCurrentPageSeg] = useState(1);
  const [editFormData, setEditFormData] = useState({});
  const inputRefs = useRef({});
  const [rolesOptions, setRole] = useState([]); // Role options fetched from API
  // const [selectedRoles, setSelectedRoles] = useState([]); // Store selected roles
  const [totalRecords, setTotalRecords] = useState(0);
  const [prevSearchTerm, setPrevSearchTerm] = useState();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const normalizedAccountEmail = account?.username?.trim().toLowerCase();
  const actor = getActivityActor(account);
  const [titleeditUserId, settitleEditUserId] = useState(null);
  const [SegditUserId, setSegEditUserId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const {
    setLoader,
    loader,
    setToast,
    confirmationModalInput,
    setConfirmationModalInput,
    setApplicationOption,
    setSelectedRoles,
    ApplicationOption,
    setSelectapplication,
    selectedRoles,
    selectapplication,
    setConfirmationModalRlsMail,
    confirmationModalRlsMail,
    fetchUrlInReport,
    setfetchUrlInReport,
    titleSearchterm,segSearchTerm, setSegSearchTerm,
    setTitleSearchterm,confirmationModalDeleteMailForAbramBi, setConfirmationModalDeleteMailForAbramBi
  } = useContext(AppContext);

  const onPageChange = (page) => {
    setCurrentPage(page);
    // handleSearch(searchTerm)
  };

  const fetchRoles = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get("/roles");
      if (response.data) {
        setRole(
          response.data?.data?.map((item) => ({
            value: item._id,
            label: item.role,
          }))
        );
      }
      // setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching roles:", error);
    }
  };
  const fetchApplications = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get("/getexternalReports");
      console.log(response, "responseresponse++");
      if (response.data) {
        setApplicationOption(
          response.data?.data?.map((item) => ({
            value: item.ID,
            label: item.NAME,
          }))
        );
      }
      // setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching roles:", error);
    }
  };
  console.log(ApplicationOption, "applications");

  const fetchUserApplications = async (email) => {
    try {
      const response = await axiosInstance.post("/get_reports_with_ids", {
        email,
      });
      console.log(response, "get_reports_with_ids");
      setfetchUrlInReport(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching applications:", error);
      setfetchUrlInReport([]);
    }
  };

  useEffect(() => {
    if (normalizedAccountEmail) fetchUserApplications(normalizedAccountEmail);
  }, [normalizedAccountEmail]);

  const fetchUsers = async (page) => {
    try {
      const response = await axiosInstance.get(
        `/getAllUsers${page ? "?page=" + page : ""}`,
        {}
      );
      setUsers(response.data);
      setTotalRecords(response.data.totalRecords); // Set the total number of users
      // setTotalPages(response.data.totalPages);  // Set the total pages based on the pagination info
      setCurrentPage(response.data.currentPage);
      // setCurrentPage(1)
      setTimeout(() => {
        setLoader(false);
      }, 2000);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoader(false);
    }
  };

  const handleExport = async (currentPage) => {
    try {
      const response = await axiosInstance.get(
        `/exportAllUsers?page=${currentPage}`,
        {
          responseType: "blob", // important for binary data
        }
      );

      // Create a blob URL for the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Default filename
      link.setAttribute(
        "download",
        `users_export_page_${currentPage}_${Date.now()}.xlsx`
      );
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting users:", error);
    }
  };
  const handleTitleExport = async (currentPage) => {
    try {
      const response = await axiosInstance.get(
        `/exportAllTitleUsers?page=${currentPage}`,
        {
          responseType: "blob", // important for binary data
        }
      );

      // Create a blob URL for the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Default filename
      link.setAttribute(
        "download",
        `users_export_page_${currentPage}_${Date.now()}.xlsx`
      );
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting users:", error);
    }
  };
  const handleSegExport = async (currentPage) => {
    try {
      const response = await axiosInstance.get(
        `/exportAllSeg?page=${currentPage}`,
        {
          responseType: "blob",
        }
      );

      // Create a blob URL for the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Default filename
      link.setAttribute(
        "download",
        `users_export_page_${currentPage}_${Date.now()}.xlsx`
      );
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting users:", error);
    }
  };

  useEffect(() => {
    console.log("Loader state changed:", loader);
  }, [loader]);

  const handleSearch = async ({ searchTerm, page }) => {
    console.log(
      "handleSearch called with searchTerm:",
      searchTerm,
      "page:",
      page
    );
    const cleanTerm = searchTerm.trim();
    setLoader(true);
    setUsers([]);
    setTotalRecords();
    setCurrentPage(currentPage);
    try {
      const response = await axiosInstance.post(
        `/findUserByEmail?searchTerm=${cleanTerm}&page=${page}`
      );
      if (response.status == 200) {
        setPrevSearchTerm(cleanTerm);
        setLoader(false);
        setUsers({
          users: response.data.users.map((item) => {
            return {
              ...item,
              role: item.role.map((role) => {
                return {
                  label: role,
                  value: role,
                };
              }),
            };
          }),
        });
        setTotalRecords(response.data.totalRecords);
        // setTotalPages(response.data.totalPages);
        setCurrentPage(response.data.currentPage);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching users:", error);
    }
  };

  const debouncedSearchTerm = useDebounce(searchTerm?.trim(), 700); // 500ms debounce

  useEffect(() => {
    console.log(
      "debouncedSearchTerm",
      debouncedSearchTerm,
      "currentPage",
      currentPage
    );
    if (debouncedSearchTerm) {
      if (prevSearchTerm !== searchTerm) {
         setCurrentPage(1); 
        handleSearch({ searchTerm: searchTerm, page: 1 });
      } else {
        handleSearch({ searchTerm: searchTerm, page: currentPage });
      }
    } else {
      setLoader(true);
      fetchUsers(currentPage);
      fetchRoles();
      fetchApplications();
    }
  }, [debouncedSearchTerm, currentPage]);
  useEffect(()=>{
    setSearchTerm("")
    setTitleSearchterm("")
    setSegSearchTerm("")
  },[activeTab])

  // Handle save edited user

  const check_rlsExistance = async (mail) => {
    setLoader(true);
    try {
      const response = await axiosInstance.post("/check-rls-mail", {
        email: mail,
      });
      console.log("response For the existence", response.data);

      return response?.data?.exists;
    } catch (error) {
      console.error("Error fetching roles:", error);
      return false;
    } finally {
      setLoader(false);
    }
  };
  const handleSave = async (userId, userMail, userName) => {
    console.log("userId", userId);
    const originalUser = users.users.find((user) => user.mail === editUserId);
    const originalRoles = originalUser?.role?.map((role) => role.label) || [];

    const newRoles = selectedRoles
      ? Array.isArray(selectedRoles)
        ? selectedRoles.map((r) => r.label)
        : [selectedRoles.label]
      : [];

    const haveRolesChanged =
      JSON.stringify([...originalRoles].sort()) !==
      JSON.stringify([...newRoles].sort());

    console.log("rolechanged", originalRoles, newRoles);

    let exists;

    if (originalRoles.includes("Viewer") && !newRoles.includes("Viewer")) {
      exists = await check_rlsExistance(userMail);
    }

    if (!exists) {
      continuehandleSave(userId, userName);
    } else {
      console.log("itemInElse", userId);
      setConfirmationModalRlsMail({
        mail: userMail,
        userId: userId,
        show: true,
      });
    }
  };

  const deleteRlsLinked = async (email) => {
    setLoader(true);
    try {
      const response = await axiosInstance.delete("/delete-rls-mail", {
        data: { email: email, ...actor },
      });

      if (response.status === 200) {
        // setLoader(false);
        console.log("delte data", response.data);
        setConfirmationModalDeleteMailForAbramBi({
          show: false,
          mail: "",
          userId: "",
        });
          setConfirmationModalRlsMail({
          show: false,
          mail: "",
          userId: "",
        });
      }
    } catch (error) {
      setLoader(false);

      console.error("Error deleting report card:", error);
    }
  };

  const deleteReportCardRls = async (mail, userId) => {
    await deleteRlsLinked(mail);
    await deleteAdUser(userId)
  };
  const deleteReportCardRlsUpdate = async (mail, userId) => {
    await deleteRlsLinked(mail);
    await continuehandleSave(userId,mail);
  };

  const continuehandleSave = async (userId, userName) => {
    // Find the original user object from the users array
    const originalUser = users.users.find((user) => user.mail === editUserId);
    // Get the original roles, formatted for comparison
    const originalRoles = originalUser?.role?.map((role) => role.label) || [];
    // Handle roles safely (empty array if no valid role is selected)
    const newRoles =
      selectedRoles && selectedRoles.label ? [selectedRoles.label] : [];

    // // const originalApplications = originalUser?.ID || [];
    // const newApplications = (selectapplication || []).map((app) => app.value);
    // console.log(newApplications, "newApplications");
    // Check if any changes were made
    const isFirstNameChanged =
      editFormData?.first_name !== originalUser?.displayName;
    const isEmailChanged =
      editFormData?.invitedUserEmailAddress !== originalUser?.mail;

    // Check if roles have changed (compare arrays)
    const haveRolesChanged =
      JSON.stringify(originalRoles.sort()) !== JSON.stringify(newRoles.sort());

    // const haveApplicationsChanged =
    //   JSON.stringify(originalApplications.sort()) !==
    //   JSON.stringify(newApplications.sort());
    if (
      !isFirstNameChanged &&
      !isEmailChanged &&
      !haveRolesChanged
      // !haveApplicationsChanged
    ) {
      // No changes detected, show a toast and exit the function
      setToast({ show: true, type: "info", message: "No changes were made." });
      setEditUserId(null); // Exit edit mode
      setConfirmationModalDeleteMailForAbramBi({
        show: false,
        id: "",
        userId: "",
      });
         setConfirmationModalRlsMail({
        show: false,
        id: "",
        userId: "",
      });
      return;
    }

    setLoader(true);

    const body = {
      userId,
      ...actor,
      updates: {
        ...editFormData,
        role: newRoles,
        // reports: newApplications,
        last_name: "", // You might want to handle this differently if `last_name` is a real field
      },
    };

    try {
      const response = await axiosInstance.post(`/updateUser`, body);
      if (response.status === 200) {
        setSearchTerm("");
        setLoader(true);

         fetchUsers(currentPage);
        fetchUserApplications(userName);

        setToast({
          show: true,
          type: "success",
          message: "User updated successfully",
        });
        setConfirmationModalRlsMail({
          show: false,
          id: "",
          userId: "",
        });
        setEditUserId(null);
      } else {
        // Handle cases where API returns a non-200 status but doesn't throw an error
        setToast({
          show: true,
          type: "error",
          message: "An unexpected error occurred",
        });
        setConfirmationModalRlsMail({
          show: false,
          id: "",
          userId: "",
        });
        setEditUserId(null);
      }
    } catch (error) {
      setToast({ show: true, type: "info", message: "Something went wrong" });
      console.error("Error updating user:", error);
    } finally {
      setLoader(false);
      setConfirmationModalRlsMail({
        show: false,
        id: "",
        userId: "",
      });
    }
  };
  const handleTabSelect = (tabName) => {
    setActiveTab(tabName);
    setDropdownOpen(false); 
  };
  const handleCancelEdit = () => {
    setEditUserId(null);
    setEditFormData({});
    setSelectedRoles([]);
    setSelectapplication([]);
    setToast({
      show: true,
      type: "success",
      message: "No changes were made",
    });
  };

  const handleClearSearch = () => {
    setSearchTerm(""); // Clear search term
    setCurrentPage(1); // Reset page number
    setEditUserId(null); // Close any open select boxes
    // setSelectedRoles(null); // Reset roles
    setRefreshKey((prevKey) => prevKey + 1); // Force re-render
  };
  const handleTitleSearch = () => {
    console.log("clear");
    setTitleSearchterm("");
    setCurrentPageTitle(1); // Reset page number
    settitleEditUserId(null); // Close any open select boxes
    // setSelectedRoles(null); // Reset roles
    setRefreshKey((prevKey) => prevKey + 1); // Force re-render
  };
  const handleSegSearch = () => {
    console.log("clear");
    setSegSearchTerm("")
    setCurrentPageSeg(1); 
    setSegEditUserId(null); 
    setRefreshKey((prevKey) => prevKey + 1); 
  };
  const handleSearchChange = (e) => {
     const value = e?.target?.value ?? e;
    setSearchTerm(value);
    setCurrentPage(1)
  };


  const deleteAdUser = async (id) => {
    console.log("called");

    try {
      const response = await axiosInstance.post(`/deleteUserAd`, {
        id: id,
        ...actor,
      });
      if (response.status === 200) {
        setLoader(true);
        await fetchUsers(1);
        setToast({
          show: true,
          type: "success",
          message: "User deleted successfully",
        });
        setUsers((prev) => ({
          ...prev,
          users: prev.users.filter((user) => user.id !== id),
        }));
        // Reset search and refresh user list
        setSearchTerm("");
        setCurrentPage(1);
        setConfirmationModalDeleteMailForAbramBi({ mail: '', userId: '', show: false })
      } else {
        setToast({
          show: true,
          type: "error",
          message: "An unexpected error occurred",
        });
      }
    } catch (error) {
      setToast({ show: true, type: "info", message: "No changes were made." });
      console.error("Error updating user:", error);
    } finally {
      setConfirmationModalInput({ id: "", show: false });
      setLoader(false);
    }
  };
  const handleTitleSearchChange = (e) => {
     const value = e?.target?.value ?? e;
    setTitleSearchterm(value);
    setCurrentPage(1)
    setCurrentPageTitle(1);
  };
  const handleSegSearchChange = (e) => {
     const value = e?.target?.value ?? e;
    setSegSearchTerm(value);
    setCurrentPageSeg(1)
  };
    const continueDelete = async (id,email) => {
const exists = await check_rlsExistance(email);

    if (!exists) {
      deleteAdUser(id);
    } else {

      setConfirmationModalDeleteMailForAbramBi({ mail: email, userId: id, show: true });
    }
  }
  useEffect(()=>{
    console.log(confirmationModalInput,'confirmationModalInput')
  },[confirmationModalInput])

  return (
    <div className="flex flex-col h-full relative">
      {confirmationModalInput?.show && (
        <ConfirmationModalInput
          onDelete={() => continueDelete(confirmationModalInput.id,confirmationModalInput.email)}

          isOpen={confirmationModalInput.show}
          onClose={() => setConfirmationModalInput({ id: "", show: false })}
          title="Enter Super Admin Password to Confirm Deletion"
        />
      )}

{/* update */}
      {confirmationModalRlsMail?.show && (
        <ConfirmationModalRlsMail
          onUpdate={() => continuehandleSave(confirmationModalRlsMail.userId)}
          onDeleteRls={() =>
            deleteReportCardRlsUpdate(
              confirmationModalRlsMail?.mail,
              confirmationModalRlsMail?.userId
            )
          }
          isOpen={confirmationModalRlsMail}
          onClose={() =>
            setConfirmationModalRlsMail({
              show: false,
              mail: "",
              userId: "",
            })
          }
          title={
            "There is RLS or Reports/Applications associated with this User. Please select one option to proceed."
          }
        />
      )}
      {/* delete */}
          {confirmationModalDeleteMailForAbramBi?.show && (
              <ConfirmationModalDeleteMail
                // onUpdate={() => continuehandleSave(confirmationModalDeleteMailForAbramBi.userId)}
                   onUpdate={() => deleteAdUser(confirmationModalDeleteMailForAbramBi.userId)} 
                onDeleteRls={() =>
                 
                  deleteReportCardRls(
                    confirmationModalDeleteMailForAbramBi?.mail,
                    confirmationModalDeleteMailForAbramBi?.userId
                  )
                }
                isOpen={confirmationModalDeleteMailForAbramBi}
                onClose={() =>
                  setConfirmationModalDeleteMailForAbramBi({
                    show: false,
                    mail: "",
                    userId: "",
                  })
                }
                title={
                  "All RLS and assigned reports related to this user will be removed."
                }
              />
            )}
 <div className="flex justify-between items-center mb-1 relative">
      {/* Dropdown / Tab Switch */}
      <div className="relative w-full md:w-auto mb-2 md:mb-0">
        <div className="flex items-center">
          <button
            className={`px-6 py-2 font-medium border-b-2 transition-colors duration-200 ${
              activeTab === "Abrams BI User Management" || "Title List User Management" || "SEG User Management" 
                ? "border-[#F87171] text-[#F87171]"
                : "text-gray-500 border-transparent"
            }`}
            onClick={() => setDropdownOpen((prev) => !prev)}
          >
            {activeTab}
            <span className="ml-2 text-gray-500">▼</span>
          </button>
        </div>

        {dropdownOpen && (
          <div className="absolute left-0 mt-1 bg-white border rounded-lg shadow-md z-10 w-max">
            <button
              className={`block px-6 py-2 text-sm w-full text-left ${
                activeTab === "Abrams BI User Management"
                  ? "bg-gray-100 text-[#F87171]"
                  : "hover:bg-gray-100 text-gray-700"
              }`}
              onClick={() => handleTabSelect("Abrams BI User Management")}
            >
              Abrams BI User Management
            </button>
            <button
              className={`block px-6 py-2 text-sm w-full text-left ${
                activeTab === "Title List User Management"
                  ? "bg-gray-100 text-[#F87171]"
                  : "hover:bg-gray-100 text-gray-700"
              }`}
              onClick={() => handleTabSelect("Title List User Management")}
            >
              Title List User Management
            </button>
            <button
          className={`block px-6 py-2 text-sm w-full text-left ${
            activeTab === "SEG User Management"
              ? "bg-gray-100 text-[#F87171]"
              : "hover:bg-gray-100 text-gray-700"
          }`}
          onClick={() => handleTabSelect("SEG User Management")}
        >
          SEG User Management
        </button>
          </div>
        )}
      </div>

      {/* Right side: Search + Buttons */}
      <div className="flex md:w-auto w-full flex-col sm:flex-row items-center space-y-2 sm:space-y-0 space-x-2">
        {/* Search */}
        <div className="relative flex-1 md:w-auto w-full flex justify-end">
          <input
            type="text"
            placeholder="Search by Username, Email or Role."
            className="py-2 px-2 sm:text-[14px] text-[10px] pl-10 rounded-lg border-[2px] md:w-[310px] w-full focus:border-blue-500 focus:outline-none"
            // value={
            //   activeTab === "Abrams BI User Management"
            //     ? searchTerm
            //     : titleSearchterm
            // }
             value={
          activeTab === "Abrams BI User Management"
            ? searchTerm
            : activeTab === "Title List User Management"
            ? titleSearchterm
            : segSearchTerm 
        }
            // onChange={(e) =>
            //   activeTab === "Abrams BI User Management"
            //     ? handleSearchChange(e)
            //     : handleTitleSearchChange(e)
            // }
            onChange={(e) =>
          activeTab === "Abrams BI User Management"
            ? handleSearchChange(e)
            : activeTab === "Title List User Management"
            ? handleTitleSearchChange(e)
            : handleSegSearchChange(e) 
        }
          onPaste={(e) => {
  e.preventDefault();
  const text = e.clipboardData.getData("text").trim();
  const fakeEvent = { target: { value: text } };

  if (activeTab === "Abrams BI User Management") {
    handleSearchChange(fakeEvent);
  } else if (activeTab === "Title List User Management") {
    handleTitleSearchChange(fakeEvent);
  } else if (activeTab === "SEG User Management") {
    handleSegSearchChange(fakeEvent);
  }
}}

          />
          <FaSearch className="absolute left-3 top-3 text-gray-500" />
        </div>

        {/* Buttons */}
        <div className="flex gap-2">
          <button
            className={`text-white sm:text-[14px] text-[12px] w-full px-8 md:px-4 py-2 rounded-lg focus:outline-none whitespace-nowrap ${
              loader ||
             !(
            activeTab === "Abrams BI User Management"
              ? searchTerm?.length
              : activeTab === "Title List User Management"
              ? titleSearchterm?.length
              : segSearchTerm?.length
          )
                ? "bg-[#F87171] cursor-not-allowed"
                : "bg-red-600 cursor-pointer"
            } transition-colors duration-200 active:bg-[#F87171]`}
            onClick={
          activeTab === "Abrams BI User Management"
            ? handleClearSearch
            : activeTab === "Title List User Management"
            ? handleTitleSearch
            : handleSegSearch
        }
             disabled={
          !(
            activeTab === "Abrams BI User Management"
              ? searchTerm?.length
              : activeTab === "Title List User Management"
              ? titleSearchterm?.length
              : segSearchTerm?.length
          )
        }
          >
            Clear
          </button>

          <button
            className={`text-white sm:text-[14px] text-[12px] w-full px-6 md:px-4 sm:py-2 py-1 rounded-lg focus:outline-none whitespace-nowrap ${
              loader ? "bg-[#F87171]" : "bg-red-600"
            } transition-colors duration-200 active:bg-[#F87171]`}
            onClick={() => navigate("/user-management/add-user")}
          >
            Add User
          </button>

          <button
            className={`text-white sm:text-[14px] text-[12px] w-full px-6 md:px-4 sm:py-2 py-1 rounded-lg focus:outline-none whitespace-nowrap ${
              loader ? "bg-[#F87171]" : "bg-red-600"
            } transition-colors duration-200 active:bg-[#F87171]`}
            onClick={() =>
          activeTab === "Abrams BI User Management"
            ? handleExport(currentPage)
            : activeTab === "Title List User Management"
            ? handleTitleExport(currentPageTitle)
            : handleSegExport(currentPageSeg) 
        }
          >
            Export All
          </button>
        </div>
      </div>
    </div>
      {/* <div className="flex justify-between items-center mb-1">
        {activeTab === "Abrams BI User Management" && (
          <>
            <div className="w-full flex md:mb-0 mb-2 ">
              <button
                className={`px-6 w-full md:mb-0 mb-2 md:w-auto font-medium ${
                  activeTab === "Abrams BI User Management"
                    ? "border-b-2 border-[#F87171] text-[#F87171]"
                    : "text-gray-500"
                }`}
                onClick={() =>
                  setActiveTab((prev) =>
                    prev === "Abrams BI User Management" ? "  Title List User Management" : "Abrams BI User Management"
                  )
                }
              >
                {activeTab}
              </button>
            </div>
         
            <div className="flex md:w-auto w-full flex-col sm:flex-row items-center space-y-2 sm:space-y-0 space-x-2">
    
              <div className="relative flex-1 md:w-auto w-full flex justify-end  ">
                <input
                  type="text"
                  placeholder="Search by Username, Email or Role."
                  className="py-2 px-2 sm:text-[14px] text-[10px] pl-10 rounded-lg border-[2px] md:w-[310px] w-full focus:border-blue-500 focus:outline-none"
                  value={searchTerm}
                  onChange={(e) => handleSearchChange(e)}
                  onPaste={(e) => {
                    e.preventDefault();
                    const text = e.clipboardData.getData("text").trim();
                    setSearchTerm(text);
                  }}
                />
                <FaSearch className="absolute left-3 top-3 text-gray-500" />
              </div>
              <div className="flex gap-2">
                <button
                  className={`text-white  sm:text-[14px] text-[12px] w-full px-8 md:px-4 py-2 rounded-lg focus:outline-none whitespace-nowrap ${
                    loader || !searchTerm.length
                      ? "bg-[#F87171] cursor-not-allowed"
                      : "bg-red-600 cursor-pointer"
                  } transition-colors duration-200 active:bg-[#F87171]`}
                  onClick={handleClearSearch}
                  disabled={!searchTerm.length}
                >
                  Clear
                </button>
                <button
                  className={`text-white sm:text-[14px] text-[12px]  w-full px-6 md:px-4 sm:py-2 py-1  rounded-lg focus:outline-none whitespace-nowrap ${
                    loader ? "bg-[#F87171]" : "bg-red-600"
                  } transition-colors duration-200 active:bg-[#F87171]`}
                  onClick={() => navigate("/user-management/add-user")}
                >
                  Add User
                </button>

                <button
                  className={`text-white sm:text-[14px] text-[12px]  w-full px-6 md:px-4 sm:py-2 py-1  rounded-lg focus:outline-none whitespace-nowrap ${
                    loader ? "bg-[#F87171]" : "bg-red-600"
                  } transition-colors duration-200 active:bg-[#F87171]`}
                  onClick={() => handleExport(currentPage)}
                >
                  Export All
                </button>
              </div>
            </div>
          </>
        )}
        {activeTab === "  Title List User Management" && (
          <>
            <div className="w-full flex md:mb-0 mb-2 ">
              <button
                className={`px-6 w-full md:mb-0 mb-2 md:w-auto font-medium ${
                  activeTab === "  Title List User Management"
                    ? "border-b-2 border-[#F87171] text-[#F87171]"
                    : "text-gray-500"
                }`}
                onClick={() =>
                  setActiveTab((prev) =>
                    prev === "  Title List User Management" ? "Abrams BI User Management" : "  Title List User Management"
                  )
                }
              >
                {activeTab}
              </button>

            </div>
            <div className="flex md:w-auto w-full flex-col sm:flex-row items-center space-y-2 sm:space-y-0 space-x-2">
         
              <div className="relative flex-1 md:w-auto w-full flex justify-end  ">
                <input
                  type="text"
                  placeholder="Search by Username, Email or Role."
                  className="py-2 px-2 sm:text-[14px] text-[10px] pl-10 rounded-lg border-[2px] md:w-[310px] w-full focus:border-blue-500 focus:outline-none"
                  value={titleSearchterm}
                  onChange={(e) => handleTitleSearchChange(e)}
                  onPaste={(e) => {
                    e.preventDefault();
                    const text = e.clipboardData.getData("text").trim();
                    setTitleSearchterm(text);
                  }}
                />
                <FaSearch className="absolute left-3 top-3 text-gray-500" />
              </div>
              <div className="flex gap-2">
                <button
                  className={`text-white  sm:text-[14px] text-[12px] w-full px-8 md:px-4 py-2 rounded-lg focus:outline-none whitespace-nowrap ${
                    loader || !titleSearchterm?.length
                      ? "bg-[#F87171] cursor-not-allowed"
                      : "bg-red-600 cursor-pointer"
                  } transition-colors duration-200 active:bg-[#F87171]`}
                  onClick={handleTitleSearch}
                  disabled={!titleSearchterm?.length}
                >
                  Clear
                </button>
                <button
              className={`text-white sm:text-[14px] text-[12px]  w-full px-6 md:px-4 sm:py-2 py-1  rounded-lg focus:outline-none whitespace-nowrap ${
                loader ? "bg-[#F87171]" : "bg-red-600"
              } transition-colors duration-200 active:bg-[#F87171]`}
              onClick={() => navigate("/user-management/add-user")}
            >
              Add User
            </button>

                <button
              className={`text-white sm:text-[14px] text-[12px]  w-full px-6 md:px-4 sm:py-2 py-1  rounded-lg focus:outline-none whitespace-nowrap ${
                loader ? "bg-[#F87171]" : "bg-red-600"
              } transition-colors duration-200 active:bg-[#F87171]`}
              onClick={() => handleTitleExport(currentPageTitle)}
            >
              Export All
            </button>
              </div>
            </div>
          </>
        )}
      </div> */}

      {/* User Table */}
      {/* <div
        className={` ${
          users?.users?.length > 7 ? "flex-grow" : ""
        } overflow-auto`}
      > */}
      {activeTab === "Abrams BI User Management" ? (
        <div className="w-full">
          <table
            key={refreshKey}
            className="w-full table-auto rounded-lg  border-2 border-gray-300"
            // className={`w-full table-auto ${
            //   users?.users?.length > 5 ? "h-full" : ""
            // } bg-white rounded-lg shadow-md border-2 border-gray-300`}
          >
            <thead className="bg-gray-200">
              <tr className="text-left sm:text-[14px] text-[11px]  font-semibold text-gray-700 border-b border-gray-300">
                <th className="px-2 py-1 border-r border-gray-300 text-center">
                  User Name
                </th>
                <th className="px-2 py-1 border-r border-gray-300 text-center">
                  Email
                </th>
                <th className="px-2 py-1 border-r border-gray-300 text-center">
                  Role
                </th>
                {/* <th className="px-2 py-1 border-r border-gray-300 text-center w-[200px]  max-w-[200px] min-w-[200px]">
                  Application
                </th> */}
                <th className="px-2 py-1 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users?.users?.filter((user) => user?.mail).length ? (
                users.users
                  .filter((user) => user.mail)
                  .map((user) => (
                    <tr
                      key={user.id}
                      className="border-b border-gray-300  sm:text-[12px] text-[10px] text-gray-700"
                    >
                      {editUserId === user.mail ? (
                        <>
                          <td className="px-2 py-1 border-r border-gray-300 text-center">
                            <input
                              ref={(el) =>
                                (inputRefs.current[`first_name-${user.id}`] =
                                  el)
                              }
                              type="text"
                              value={
                                editFormData.first_name ||
                                user.displayName ||
                                ""
                              }
                              onChange={(e) =>
                                setEditFormData({
                                  ...editFormData,
                                  first_name: e.target.value,
                                })
                              }
                              onKeyDown={(e) =>
                                e.key === "Tab" &&
                                inputRefs.current[`email-${user.id}`]?.focus()
                              }
                              className="px-2 rounded w-full outline-none text-center"
                            />
                          </td>
                          <td className="px-2 border-r border-gray-300 text-center">
                            <input
                              ref={(el) =>
                                (inputRefs.current[`email-${user.id}`] = el)
                              }
                              type="text"
                              value={
                                editFormData.invitedUserEmailAddress ||
                                user.mail ||
                                ""
                              }
                              onChange={(e) =>
                                setEditFormData({
                                  ...editFormData,
                                  invitedUserEmailAddress: e.target.value,
                                })
                              }
                              onKeyDown={(e) =>
                                e.key === "Tab" &&
                                inputRefs.current[`role-${user.id}`]?.focus()
                              }
                              className="px-2 rounded w-full outline-none text-center"
                            />
                          </td>
                          <td className="px-2 max-w-[200px] border-r border-gray-300 text-center">
                            <Select
                              ref={(el) =>
                                (inputRefs.current[`role-${user.id}`] = el)
                              }
                              id="role"
                              value={selectedRoles}
                              onChange={(selected) =>
                                setSelectedRoles(selected)
                              }
                              options={rolesOptions}
                              className="mt-1"
                              isClearable={true}
                              menuPortalTarget={document.body}
                              menuPlacement="auto"
                              isDisabled={user.mail === normalizedAccountEmail}
                              menuShouldScrollIntoView={false}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                menuList: (provided) => ({
                                  ...provided,
                                  maxHeight: isSmallScreen ? "80px" : "150px",
                                  overflowY: "auto",
                                  fontSize: isSmallScreen ? "10px" : "14px",
                                }),
                              }}
                              required
                            />
                          </td>
                          {/* <td className="px-2 max-w-[200px] border-r border-gray-300 text-center">
                            <Select
                              id="application"
                              value={selectapplication}
                              onChange={(selected) =>
                                setSelectapplication(selected)
                              }
                              options={ApplicationOption}
                              className="mt-1"
                              isClearable={true}
                              isMulti
                              menuPortalTarget={document.body}
                              menuPlacement="auto"
                              menuShouldScrollIntoView={false}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                menuList: (provided) => ({
                                  ...provided,
                                  maxHeight: isSmallScreen ? "80px" : "150px",
                                  overflowY: "auto",
                                  fontSize: isSmallScreen ? "10px" : "14px",
                                }),
                              }}
                              required
                            />
                          </td> */}
                          <td className="px-2 text-center">
                            <div className="flex gap-2 justify-center">
                              <button
                                onClick={() =>
                                  handleSave(
                                    user.id,
                                    user?.mail,
                                    normalizedAccountEmail
                                  )
                                }
                                className="text-green-600 hover:text-green-800"
                              >
                                <FaSave />
                              </button>
                              <button
                                onClick={handleCancelEdit}
                                className="text-gray-600 cursor-pointer"
                              >
                                <FaTimes />
                              </button>
                            </div>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="px-2 td-1920 td-1520 td-1000 td-2220 py-2.5 border-r min-w-[70px] border-gray-300 text-center ">
                            {user.displayName}
                          </td>
                          <td className="px-2 py-2.5 border-r min-w-[70px] border-gray-300 text-center">
                            {user.mail}
                          </td>
                          <td className="px-2 py-2.5 border-r min-w-[150px] border-gray-300 text-center">
                            {user.role?.length
                              ? user.role.map((item) => item.label).join(",")
                              : "-"}
                          </td>
                          {/* <td className="px-2 py-2.5 border-r border-gray-300 text-center">
                            {user.reports?.length
                              ? user.reports.map((app) => app.label).join(", ")
                              : "-"}
                          </td> */}
                          <td className="px-2 py-2.5 text-center">
                            <button
                              onClick={() => {
                                console.log(
                                  "user email",
                                  user?.mail,
                                  normalizedAccountEmail
                                );
                                if (user?.mail === normalizedAccountEmail) {
                                  setEditUserId(user.mail);
                                  setEditFormData({
                                    first_name: user.displayName,
                                    invitedUserEmailAddress: user.mail,
                                  });
                                  setSelectedRoles(
                                    user?.role.length > 0
                                      ? user?.role?.map((role) => ({
                                          value: role.value,
                                          label: role.label,
                                        }))
                                      : []
                                  );
                                  setSelectapplication(
                                    user?.reports?.length > 0
                                      ? user?.reports?.map((app) => ({
                                          value: app.value,
                                          label: app.label,
                                        }))
                                      : []
                                  );
                                } else {
                                  setEditUserId(user.mail);
                                  setEditFormData({
                                    first_name: user.displayName,
                                    invitedUserEmailAddress: user.mail,
                                  });
                                  setSelectedRoles(
                                    user?.role.length > 0
                                      ? user?.role?.map((role) => ({
                                          value: role.value,
                                          label: role.label,
                                        }))
                                      : []
                                  );
                                  setSelectapplication(
                                    user?.reports?.length > 0
                                      ? user?.reports?.map((app) => ({
                                          value: app.value,
                                          label: app.label,
                                        }))
                                      : []
                                  );
                                }
                              }}
                              className="text-blue-600 hover:text-blue-800 mr-2"
                            >
                              <FaEdit />
                            </button>
                            <button
                              onClick={() => {
                                console.log(
                                  "user email",
                                  user?.mail,
                                  normalizedAccountEmail
                                );
                                if (user?.mail === normalizedAccountEmail) {
                                  setToast({
                                    show: true,
                                    type: "error",
                                    message: "Admins cannot delete their user",
                                  });

                                  return;
                                }
                                setConfirmationModalInput({
                                  id: user?.id,
                                    email: user?.mail,
                                  show: true,
                                });
                              }}
                              className="mr-2"
                            >
                              <FaTrash className="cursor-pointer text-red-600" />
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))
              ) : (
                <tr>
                  <td
                    colSpan={4}
                    className="text-center sm:text-[14px] text-[10px] py-4 text-gray-500 font-semibold"
                  >
                    {loader ? "Loading..." : "Users Not Found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) :activeTab === "SEG User Management" ? (
  // SEG User Management component
  <SegUserManagement
    refreshKey={refreshKey}
    searchTerm={searchTerm}
    setSearchTerm={setSearchTerm}
    SegditUserId={SegditUserId}
    setSegEditUserId={setSegEditUserId}
    // setCurrentPageTitle={setCurrentPageTitle}
    setCurrentPageSeg={setCurrentPageSeg}
    currentPageSeg={currentPageSeg}
  />
) : (
        <UserManagementTitleList
          refreshKey={refreshKey}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          titleeditUserId={titleeditUserId}
          settitleEditUserId={settitleEditUserId}
          setCurrentPageTitle={setCurrentPageTitle}
          currentPageTitle={currentPageTitle}
        />
      )}
      {activeTab === "Abrams BI User Management" && users?.users?.length > 0 && (
        <div className="w-full absolute bottom-0 flex justify-end mt-2">
          <Pagination
            totalItems={totalRecords}
            itemsPerPage={10}
            currentPage={currentPage}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default UserManagement;
